import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
    from { opacity: 0 }
    to { opacity: 1 }
`;

const fadeOut = keyframes`
    from { opacity: 1 }
    to { opacity: 0 }
`;

export const FadeIn = styled.div<{ over?: string, after?: any, disabled?: boolean }>`
    ${p => p.disabled ? '' : css`
        opacity: 0;
        animation: ${fadeIn} ${p.over || '300ms'} ease-out;
        animation-fill-mode: forwards;
        animation-delay: ${p.after || '0ms'};
    `}
`;

export const FadeOut = styled.div<{ after?: any, disabled?: boolean }>`
    ${p => p.disabled ? '' : css`
        opacity: 1;
        animation: ${fadeOut} 300ms ease-in;
        animation-fill-mode: forwards;
        animation-delay: ${p.after || 0}ms;
    `}
`;

const dropIn = keyframes`
    from { opacity: 0; transform: translateY(-2rem) }
    to { opacity: 1; transform: translateY(0rem) }
`;

export const DropIn = styled.div`
    animation: ${dropIn} 200ms ease-out;
    animation-fill-mode: forwards;
`;
